export const useClickStore = defineStore('click', () => {
	const customerSessionId = ref<string | null>(null);

	customerSessionId.value = useId();

	return {customerSessionId};
});
